import styled, { CSSObject } from '@emotion/styled';

type ButtonProps = {
  /**
   * @description 按鈕樣式
   */
  $type?: 'text' | 'outlined' | 'contained';
  /**
   * @description 按鈕顏色
   */
  $color: string;
};

const Button = styled('button', { label: 'v2-button' })<ButtonProps>(
  ({ $type, $color, disabled }) => {
    const styles: CSSObject = {
      width: '100%',
      height: '2.25rem',
      borderRadius: '0.25rem',
      fontSize: '0.9rem',
      fontWeight: 500,
    };
    const color = disabled ? '#D9D9D9' : $color;
    switch ($type) {
      case 'text':
        styles.backgroundColor = 'transparent';
        styles.color = color;
        styles.border = 'none';
        break;
      case 'outlined':
        styles.backgroundColor = 'transparent';
        styles.color = color;
        styles.border = `0.025rem solid ${color}`;
        break;
      case 'contained':
        styles.backgroundColor = color;
        styles.color = '#fff';
        styles.border = 'none';
        break;
      default:
        break;
    }
    return styles;
  }
);

export default Button;
